let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bEf6f")).then(() => parcelRequire('jyj7M'));